document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('variant-selector-modal');
  if (!modal) return;

  const modalTitle = modal.querySelector('#variant-modal-title');
  const modalImageWrapper = modal.querySelector('#variant-modal-product-image-wrapper');
  const modalDescriptionWrapper = modal.querySelector('#variant-modal-product-description-wrapper');
  const modalBody = modal.querySelector('#variant-modal-product-details');
  const cartContentWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  const freeGiftConfig = document.getElementById('gymtier-free-gift-config');
  const cartLoadingMarkup = '<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
  const productJsonCache = new Map();

  const freeGiftEnabled = freeGiftConfig?.dataset.enabled === 'true';
  const freeGiftThreshold = Number(freeGiftConfig?.dataset.threshold || 0);
  const freeGiftProductId = Number(freeGiftConfig?.dataset.productId || 0);
  const freeGiftProductHandle = freeGiftConfig?.dataset.productHandle || '';
  const freeGiftAddedStorageKey = 'gymtierFreeGiftAddedAt';
  const freeGiftAddedVisibleMs = 5000;
  let freeGiftAddedTimeoutId = null;
  let isEnforcingFreeGiftRules = false;
  let currentModalContext = {
    openedFromCartSidebar: false,
    refreshMainCart: false,
    isFreeGift: false
  };

  const getCartCountBubble = () => document.querySelector('[data-cart-count]');

  const normalizeCartDetail = (detail) => {
    if (!detail) return null;
    if (detail.cart) return detail.cart;
    return detail;
  };

  const showError = (message) => {
    if (window.halo && typeof window.halo.showWarning === 'function') {
      window.halo.showWarning(message);
      return;
    }

    window.alert(message);
  };

  const fetchCartJson = () => fetch('/cart.js').then((response) => response.json());

  const fetchSidebarHtml = () => fetch('/cart?view=ajax_side_cart').then((response) => response.text());

  const fetchProductJsonByHandle = (handle) => {
    if (!handle) return Promise.reject(new Error('Missing product handle.'));

    if (!productJsonCache.has(handle)) {
      productJsonCache.set(handle, fetch(`/products/${handle}.js`).then((response) => {
        if (!response.ok) {
          throw new Error('Could not load product options.');
        }

        return response.json();
      }));
    }

    return productJsonCache.get(handle);
  };

  const getFreeGiftAddedTimestamp = () => Number(window.localStorage.getItem(freeGiftAddedStorageKey) || 0);

  const markFreeGiftAdded = () => {
    window.localStorage.setItem(freeGiftAddedStorageKey, String(Date.now()));
  };

  const clearFreeGiftAdded = () => {
    window.localStorage.removeItem(freeGiftAddedStorageKey);
  };

  const hasRecentFreeGiftAdded = () => {
    const timestamp = getFreeGiftAddedTimestamp();
    if (!timestamp) return false;

    const isRecent = Date.now() - timestamp < freeGiftAddedVisibleMs;
    if (!isRecent) {
      clearFreeGiftAdded();
    }

    return isRecent;
  };

  const syncFreeGiftCallouts = () => {
    const shouldShowAddedState = hasRecentFreeGiftAdded();
    const timestamp = getFreeGiftAddedTimestamp();

    if (freeGiftAddedTimeoutId) {
      window.clearTimeout(freeGiftAddedTimeoutId);
      freeGiftAddedTimeoutId = null;
    }

    document.querySelectorAll('[data-free-gift-card][data-free-gift-added="true"]').forEach((card) => {
      if (shouldShowAddedState) {
        card.hidden = false;
      } else {
        card.remove();
      }
    });

    if (shouldShowAddedState && timestamp) {
      const remainingMs = Math.max(freeGiftAddedVisibleMs - (Date.now() - timestamp), 0);
      freeGiftAddedTimeoutId = window.setTimeout(() => {
        syncFreeGiftCallouts();
      }, remainingMs + 20);
    }
  };

  const updateCartSidebar = (html, cart) => {
    if (cartContentWrapper && html) {
      cartContentWrapper.innerHTML = html;
      Array.from(cartContentWrapper.getElementsByTagName('script')).forEach((oldScript) => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }

    const cartCountBubble = getCartCountBubble();
    if (cartCountBubble && cart) {
      cartCountBubble.textContent = cart.item_count;
    }
  };

  const refreshSidebarUi = (cart) => {
    if (!cartContentWrapper) {
      const cartCountBubble = getCartCountBubble();
      if (cartCountBubble && cart) {
        cartCountBubble.textContent = cart.item_count;
      }

      return Promise.resolve(cart);
    }

    return fetchSidebarHtml().then((html) => {
      updateCartSidebar(html, cart);
      syncFreeGiftCallouts();
      return cart;
    });
  };

  const showCartSidebarLoading = () => {
    document.body.classList.add('cart-sidebar-show');

    if (!cartContentWrapper) return;
    if (!cartContentWrapper.querySelector('.loading-overlay')) {
      cartContentWrapper.insertAdjacentHTML('afterbegin', cartLoadingMarkup);
    }

    cartContentWrapper.classList.add('is-loading');
  };

  const openModal = (product, context = {}) => {
    currentModalContext = {
      openedFromCartSidebar: !!context.openedFromCartSidebar,
      refreshMainCart: !!context.refreshMainCart,
      isFreeGift: !!context.isFreeGift
    };

    modalTitle.textContent = product.title;
    modal.classList.toggle('variant-modal--cart-sidebar', currentModalContext.openedFromCartSidebar);

    modalImageWrapper.innerHTML = '';
    if (product.featured_image) {
      const img = document.createElement('img');
      img.src = product.featured_image.replace(/(\.[^.]*)$/, '_720x$1');
      img.alt = product.title;
      modalImageWrapper.appendChild(img);
    }

    modalDescriptionWrapper.innerHTML = '';
    if (product.description) {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = 'Description';
      const content = document.createElement('div');
      content.className = 'description-content';
      content.innerHTML = product.description;
      details.appendChild(summary);
      details.appendChild(content);
      modalDescriptionWrapper.appendChild(details);
    }

    modalBody.innerHTML = '';

    const wrapper = document.createElement('div');
    wrapper.className = 'option-buttons-wrapper';

    const title = document.createElement('p');
    title.className = 'option-buttons-title';
    title.textContent = 'Select Size';
    wrapper.appendChild(title);

    product.variants.forEach((variant) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'option-button';
      button.textContent = variant.option1;
      button.dataset.variantId = variant.id;
      if (!variant.available) button.disabled = true;
      wrapper.appendChild(button);
    });

    modalBody.appendChild(wrapper);
    modal.style.display = 'flex';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.toggle('variant-modal-open-from-cart', currentModalContext.openedFromCartSidebar);
  };

  const closeModal = () => {
    modal.style.display = 'none';
    modal.classList.remove('is-open');
    modal.classList.remove('variant-modal--cart-sidebar');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('variant-modal-open-from-cart');
    currentModalContext = {
      openedFromCartSidebar: false,
      refreshMainCart: false,
      isFreeGift: false
    };
  };

  const getFreeGiftItems = (cart) => {
    if (!freeGiftEnabled || !freeGiftProductId || !cart?.items) return [];
    return cart.items.filter((item) => Number(item.product_id) === freeGiftProductId);
  };

  const getFreeGiftQuantity = (cart) => getFreeGiftItems(cart).reduce((count, item) => count + Number(item.quantity || 0), 0);

  const buildFreeGiftCorrections = (cart) => {
    const giftItems = getFreeGiftItems(cart);
    if (!giftItems.length) return [];

    const shouldKeepGift = Number(cart.total_price || 0) >= freeGiftThreshold;
    const corrections = [];
    let remainingAllowed = shouldKeepGift ? 1 : 0;

    giftItems.forEach((item) => {
      const currentQuantity = Number(item.quantity || 0);
      const nextQuantity = remainingAllowed > 0 ? Math.min(currentQuantity, remainingAllowed) : 0;

      if (nextQuantity !== currentQuantity) {
        corrections.push({ id: item.key, quantity: nextQuantity });
      }

      remainingAllowed = Math.max(remainingAllowed - nextQuantity, 0);
    });

    return corrections;
  };

  const applyFreeGiftCorrections = (corrections) => corrections.reduce((chain, correction) => {
    return chain.then(() => fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(correction)
    }));
  }, Promise.resolve());

  const refreshAfterFreeGiftCorrection = (cart) => {
    if (!getFreeGiftItems(cart).length) {
      clearFreeGiftAdded();
    }

    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return Promise.resolve(cart);
    }

    return refreshSidebarUi(cart).then((updatedCart) => {
      document.dispatchEvent(new CustomEvent('cart-update', {
        detail: {
          cart: updatedCart
        }
      }));
      return updatedCart;
    });
  };

  const enforceFreeGiftRules = (cart = null) => {
    if (!freeGiftEnabled || !freeGiftProductId || isEnforcingFreeGiftRules) {
      return Promise.resolve(cart);
    }

    const cartPromise = cart ? Promise.resolve(cart) : fetchCartJson();

    return cartPromise
      .then((resolvedCart) => {
        const corrections = buildFreeGiftCorrections(resolvedCart);
        if (!corrections.length) {
          return resolvedCart;
        }

        isEnforcingFreeGiftRules = true;

        return applyFreeGiftCorrections(corrections)
          .then(() => fetchCartJson())
          .then((updatedCart) => refreshAfterFreeGiftCorrection(updatedCart))
          .finally(() => {
            isEnforcingFreeGiftRules = false;
          });
      })
      .catch(() => {
        isEnforcingFreeGiftRules = false;
      });
  };

  const validateFreeGiftEligibility = () => {
    if (!freeGiftEnabled || !freeGiftProductId) {
      return Promise.reject(new Error('Free gift is not configured.'));
    }

    return fetchCartJson().then((cart) => {
      if (Number(cart.total_price || 0) < freeGiftThreshold) {
        clearFreeGiftAdded();
        throw new Error('Your cart no longer qualifies for this free gift.');
      }

      if (getFreeGiftQuantity(cart) >= 1) {
        throw new Error('Your free gift is already in the cart.');
      }

      return cart;
    });
  };

  const disableFreeGiftProductPagePurchasing = () => {
    if (!freeGiftEnabled || !freeGiftProductHandle) return;

    const normalizedPath = window.location.pathname.replace(/\/+$/, '');
    if (normalizedPath !== `/products/${freeGiftProductHandle}`) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        showError('This product is only available as a free gift in the cart.');
      });

      form.querySelectorAll('button[type="submit"], button[name="add"]').forEach((button) => {
        button.disabled = true;
        if (!button.dataset.freeGiftLocked) {
          button.dataset.freeGiftLocked = 'true';
          const label = button.querySelector('span');
          if (label) {
            label.textContent = 'Free Gift Only';
          } else {
            button.textContent = 'Free Gift Only';
          }
        }
      });
    });
  };

  document.body.addEventListener('click', (event) => {
    const toggle = event.target.closest('.card-options-toggle');
    if (!toggle) return;

    event.preventDefault();

    const productItem = toggle.closest('[data-json-product]');
    const productHandle = toggle.dataset.productHandle || productItem?.dataset.productHandle || '';
    const openFrom = toggle.dataset.openFrom || '';
    const buttonLabel = toggle.querySelector('.sidebar-card-cta__label, .cart-free-gift__cta-label');
    const originalLabel = buttonLabel ? buttonLabel.textContent : '';

    const productPromise = (() => {
      if (productItem?.dataset.jsonProduct) {
        try {
          return Promise.resolve(JSON.parse(productItem.dataset.jsonProduct));
        } catch (error) {}
      }

      if (productHandle) {
        return fetchProductJsonByHandle(productHandle).then((productData) => {
          if (productItem) {
            productItem.dataset.jsonProduct = JSON.stringify(productData);
          }

          return productData;
        });
      }

      return Promise.reject(new Error('Missing product data.'));
    })();

    if (buttonLabel && productHandle) {
      buttonLabel.textContent = 'Loading...';
      toggle.disabled = true;
    }

    productPromise
      .then((productData) => {
      if (freeGiftEnabled && Number(productData.id) === freeGiftProductId && toggle.dataset.variantModalMode !== 'free-gift') {
        showError('This product is only available as a free gift in the cart.');
        return;
      }

      openModal(productData, {
        openedFromCartSidebar: openFrom === 'cart-sidebar' || !!toggle.closest('#halo-cart-sidebar'),
        refreshMainCart: openFrom === 'main-cart' || !!toggle.closest('#main-cart-items'),
        isFreeGift: toggle.dataset.variantModalMode === 'free-gift'
      });
      })
      .catch((error) => {
        showError(error?.message || 'Could not load product options.');
      })
      .finally(() => {
        if (buttonLabel && productHandle) {
          buttonLabel.textContent = originalLabel || 'Choose Options';
          toggle.disabled = false;
        }
      });
  });

  modal.addEventListener('click', (event) => {
    const optionButton = event.target.closest('.option-button');
    if (!optionButton || optionButton.disabled) return;

    const variantId = optionButton.dataset.variantId;
    const originalLabel = optionButton.textContent;
    const modalContext = { ...currentModalContext };
    optionButton.disabled = true;
    optionButton.textContent = 'Adding...';

    const validationPromise = modalContext.isFreeGift ? validateFreeGiftEligibility() : Promise.resolve();

    validationPromise
      .then(() => {
        closeModal();

        if (modalContext.openedFromCartSidebar) {
          showCartSidebarLoading();
        }

        const addPayload = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        if (modalContext.isFreeGift) {
          markFreeGiftAdded();
          addPayload.items[0].properties = {
            _gymtier_free_gift: 'true'
          };
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload)
        });
      })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            throw new Error(error.description || 'Could not add item.');
          });
        }

        return response.json();
      })
      .then(() => fetchCartJson())
      .then((cart) => enforceFreeGiftRules(cart).then(() => cart))
      .then((cart) => {
        if (modalContext.refreshMainCart) {
          window.location.reload();
          return null;
        }

        document.body.classList.add('cart-sidebar-show');

        return refreshSidebarUi(cart).then((updatedCart) => {
          document.dispatchEvent(new CustomEvent('cart-update', {
            detail: {
              cart: updatedCart
            }
          }));
          return updatedCart;
        });
      })
      .catch((error) => {
        optionButton.disabled = false;
        optionButton.textContent = originalLabel;
        showError(error.message || 'Could not add item.');
      });
  });

  modal.addEventListener('click', (event) => {
    if (event.target.matches('[data-close-modal]')) closeModal();
  });

  modal.addEventListener('mousedown', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  document.addEventListener('cart-update', (event) => {
    const cart = normalizeCartDetail(event.detail);
    if (cart) {
      if (!getFreeGiftItems(cart).length) {
        clearFreeGiftAdded();
      }

      syncFreeGiftCallouts();
      enforceFreeGiftRules(cart);
    }
  });

  disableFreeGiftProductPagePurchasing();
  syncFreeGiftCallouts();
  enforceFreeGiftRules();
});